import TagsBase from "../../BaseModels/Tags";

class TagsModel extends TagsBase {

}

export default TagsModel